<template>
  <v-card flat class="pa-3">
    <v-card-title>
      <h5>Trial {{ status === 'TERMINATED' ? 'Termination' : 'Completion' }}</h5>
      <v-spacer />
    </v-card-title>
    <v-card-text>
      <template v-if="showNotificationMessage">
        <p>You have changed the status of this trial to {{ statusText }}.</p>
        <p>
          Doing this will send a notification to the Paradigm Clinical team regarding the change in order to:
        </p>
        <ul>
          <li>Stop patient identifications for this trial</li>
          <li>
            Automatically set the status for all identified patients to "Not Eligible - Reason: Recruitment Closed"
          </li>
        </ul>
        <br />
        <p>Are you sure you want to make this change?</p>
      </template>
      <template v-else>
        <p>You have changed the status of this trial to {{ statusText }}.</p>
        <p>Doing this will:</p>
        <ul>
          <li>Stop patient identifications for this trial</li>
          <li>
            Automatically set the status for all identified patients to "Not Eligible - Reason: Recruitment Closed" this change may take up to 24 hours to apply
          </li>
        </ul>
        <br />
        <p>This cannot be undone.</p>
        <p>Are you sure you want to make this change?</p>
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <app-button-cancel @click="e => $emit('on-cancel', e)" />
      <app-button @click="e => $emit('on-save', e)">Save</app-button>
    </v-card-actions>
  </v-card>
</template>
<script>
import { permissionsMixin } from '@/mixins/permissions'

export default {
  mixins: [permissionsMixin],
  props: {
    status: { type: String, required: true },
    contracted: { type: Boolean, required: true }
  },
  computed: {
    statusText() {
      return this.status === 'TERMINATED' ? 'Terminated' : 'Completed'
    },
    showNotificationMessage() {
      if (this.hasAnyPermission('MEMBERSHIP_ADMINISTRATOR_CREATE')) {
        return false
      }
      return this.contracted
    }
  }
}
</script>
